/* eslint-disable array-callback-return */
import { Component } from 'react'
import { withRouter } from '../../../../insfrastructure/utils/with-router-component'
import { StaticValues } from '../../../../insfrastructure/services/static_values'
import { listJobTitles } from '../../../../insfrastructure/services/jobs-titles'
import { listCourses } from '../../../../insfrastructure/services/courses'
import ResponseModal from '../../../components/response-modal'
import { retrieveCandidate } from '../../../../insfrastructure/services/candidates'
import { parseJwt } from '../../../../insfrastructure/utils/JWTParser'
import { getAuthToken } from '../../../../insfrastructure/services/token-manager'
import { listSavedJobs, updateSavedJob } from '../../../../insfrastructure/services/saved-jobs'
import { jobApplies } from '../../../../insfrastructure/services/job-applies'
import { JobApplyHelper } from '../../../../insfrastructure/utils/job-apply-helper'
import ValidationModal from '../../../components/validation-modal'
import { listJobs } from '../../../../insfrastructure/services/jobs'
import savedIcon from '../../../../assets/icons/saved.svg'
import notSavedIcon from '../../../../assets/icons/not-saved.svg'
import { updateMetaTags, resetMetaTags } from '../../../../insfrastructure/utils/meta-tags'
import './styles.sass'

class JobOfferDetails extends Component<any> {
  state: Record<string, any> = {
    job_types: {},
    job_titles: {},
    education_levels: {},
    courses: {},
    skills: {},
    offer: {
      basic_info: {},
      benefits: {},
      requirements: {}
    },
    validationModal: {
      isOpen: false,
      message: '',
      missingFields: []
    }
  }

  BRLReal = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  })

  async componentDidMount() {
    this.getStaticValues();
    await this.listJobTitles();
    await this.getUserData();
    await this.retriveOffer();
    await this.checkUserApplication();
    await this.checkSavedJob();    
  }

  componentWillUnmount() {
    // Resetar meta tags ao sair da página
    resetMetaTags();
  }

  getUserData = async () => {
    const auth_token = getAuthToken();
    if(!auth_token) return;
    
    let state: any = { usertype: parseJwt(auth_token).profiles[0] };
    
    if (state.usertype === 'candidate') {
      const candidate = await retrieveCandidate();
      state.user_data = candidate;
    };

    this.setState(state);
  }

  checkSavedJob = async () => {
    if (this.state.usertype !== 'candidate') return;

    try {
      const response = await listSavedJobs(localStorage.getItem('candidate_id'));

      this.setState({ saved: response.filter(x => this.props.params?.offer_id === x.job_post+'').length > 0 });
    } catch (error) {}
  }

  toggleSavedJob = async () => {
    try {
      await updateSavedJob({
        candidate_id: localStorage.getItem('candidate_id')+'',
        job_post_id: this.props.params?.offer_id,
        is_saved: !this.state.saved
      });

      this.setState({ saved: !this.state.saved });
    } catch (error) {}
  }

  checkUserApplication = async () => {    
    if (this.state.usertype !== 'candidate') return;

    const auth_token = getAuthToken();
    if(!auth_token) return;

    const applications = await jobApplies();

    this.setState({ user_applied: applications.results.filter(x => this.props.params?.offer_id === x.jobpost_id + '').length > 0 });
  }

  retriveOffer = async () => {
    try {
      this.setState({ loading: true });

      // Esta tela é aberta a partir de dois contextos — o painel do recrutador
      // (/offers/panel) e a listagem pública (/offers) — e o mesmo id pode
      // exigir escopos diferentes. Daí a busca em duas etapas:
      //
      // 1ª: com o managerId, que ativa o escopo por empresa no backend e traz
      //     a vaga em qualquer status (inclusive cancelada).
      // 2ª: sem o managerId, quando a 1ª não encontra. O escopo por empresa
      //     (filter_manager_id -> company_id) restringe às vagas da própria
      //     empresa, então vagas públicas de terceiros só aparecem aqui.
      //
      // Vaga não-pública de outra empresa não é encontrada por nenhuma das
      // duas — que é o comportamento desejado.
      const authToken = getAuthToken();
      const jwt = authToken ? parseJwt(authToken) : null;
      const managerId =
        jwt?.profiles && !jwt.profiles.includes('candidate')
          ? jwt.manager_id
          : undefined;

      const offerId = this.props.params?.offer_id;

      let jobsData = (
        await listJobs({
          id: offerId,
          ...(managerId ? { managerId } : {}),
        })
      ).data;

      if (managerId && (!jobsData || jobsData.length === 0)) {
        jobsData = (await listJobs({ id: offerId })).data;
      }

      if (!jobsData || jobsData.length === 0) {
        throw new Error('Vaga não encontrada');
      }
      const offerResponse = jobsData[0] as any;

      // Processar habilidades separando obrigatórias e opcionais
      const jobSkills = offerResponse.jobSkills || [];
      const required_skills = jobSkills
        .filter((x: any) => {
          const skillType = (x.skillType || '').toUpperCase();
          return skillType === 'REQUIRED';
        })
        .map((x: any) => parseInt(x.skill.id))
        .filter((id: number) => !isNaN(id));
      
      const desired_skills = jobSkills
        .filter((x: any) => {
          const skillType = (x.skillType || '').toUpperCase();
          return skillType === 'DESIRED' || skillType === 'OPTIONAL';
        })
        .map((x: any) => parseInt(x.skill.id))
        .filter((id: number) => !isNaN(id));

      const offer = {
        basic_info: {
          company_id: offerResponse.company.id,
          company_name: offerResponse.company.name,
          city_display_name: offerResponse.company?.city?.displayName,
          job_title_id: parseInt(offerResponse.jobTitle.id),
          job_type: offerResponse.jobType.toLowerCase(),
          job_description: offerResponse.jobDescription,
          quantity: offerResponse.quantity
        },
        benefits: {
          salary: offerResponse.salary,
          comission: offerResponse.comission,
          show_salary: offerResponse.showSalary,
          benefits: offerResponse.jobBenefits.map((x: any) => ({
            benefit_id: x.benefitId,
            benefit_name: x.benefit?.name || 'Benefício não especificado',
            value: x.value,
            time_unit: x.timeUnit?.toLowerCase(),
            description: x.description
          }))
        },
        requirements: {
          minimum_education: offerResponse.minimumEducation?.toLowerCase(),
          minimum_experience: offerResponse.minimumExperience?.toString() || '0',
          required_skills: required_skills,
          desired_skills: desired_skills,
          recommended_courses: offerResponse.recommendedCourses?.map((x: any) => x.id)
        }
      };


      this.setState({ offer, jobStatus: String(offerResponse.status || '').toLowerCase() }, () => {
        // Atualizar meta tags para preview do WhatsApp após o estado ser atualizado
        // Usar setTimeout para garantir que job_titles já esteja carregado
        setTimeout(() => {
          this.updateShareMetaTags(offer);
        }, 100);
      });
      
      setTimeout(() => {
        this.setState({ loading: false }); 
      }, 1000);
    } catch (error) {
      setTimeout(() => {
        this.setState({ loading: false }); 
      }, 500);
    }
  }

  getStaticValues = async () => {
    try {  
      const staticValues = JSON.parse(localStorage.getItem('static_values')+'') as StaticValues;

      let skills: any = {};
 
      staticValues.skills.map(item => {
        skills[item.id] = item.name;
      });
      
      this.setState({ job_types: staticValues.job_type, education_levels: staticValues.education_level, courses: staticValues.em_course, skills });
    } catch (error) {}
  }

  listJobTitles = async () => {
    try {
      const response = await listJobTitles();
      
      let job_titles: any = {};

      response.results.map(item => {
        job_titles[item.id] = item.name;
      });

      this.setState({ job_titles });
    } catch (error) {}
  }


  async listCourses() {
    try {
      const results = await listCourses();

      let courses: any = {};
      
      results.results.map(item => {
        courses[item.id] = item.course_name;
      });

      this.setState({ courses });
    } catch (error) {}
  }

  onSubmit = async () => {
    try {
      this.setState({ loading: true });

      // Usar o helper com validação
      const result = await JobApplyHelper.applyToJob(this.props.params?.offer_id);

      if (!result.success) {
        // Se for erro de validação, mostrar modal com campos faltantes
        if (result.isValidationError && result.missingFields && result.missingFields.length > 0) {
          this.setState({
            validationModal: {
              isOpen: true,
              message: result.error || 'Perfil incompleto',
              missingFields: result.missingFields
            }
          });
          this.setState({ loading: false });
          return; // Não fazer throw, apenas mostrar modal
        } else {
          throw new Error(result.error || 'Erro ao se candidatar');
        }
      }

      // Se chegou aqui, a candidatura foi realizada com sucesso
      let responseData = {
        type: 'success',
        title: 'Candidatura realizada com sucesso!',
        text: () => <></>
      };
        
      setTimeout(() => {
        this.setState({ loading: false, responseData });
      });
    } catch (error: any) {
      let responseData = {
        type: 'error',
        title: 'Ocorreu um erro inesperado',
        text: () => <></>
      };

      this.setState({ loading: false, responseData });
    }
  }

  closeValidationModal = () => {
    this.setState({
      validationModal: {
        isOpen: false,
        message: '',
        missingFields: []
      }
    });
  }

  goToProfileCompletion = () => {
    this.closeValidationModal();
    // Navegar para a página de perfil - seção de dados pessoais
    this.props.navigate('/profile/candidate/person');
  }

  updateShareMetaTags = (offerData: any) => {
    const jobTitle = this.state.job_titles[offerData.basic_info.job_title_id] || 'Vaga de Emprego';
    const companyName = offerData.basic_info.company_name || '';
    const location = offerData.basic_info.city_display_name || '';
    const salary = offerData.benefits.show_salary && offerData.benefits.salary > 0
      ? this.BRLReal.format(offerData.benefits.salary)
      : 'A combinar';
    
    // Criar descrição com informações relevantes
    let description = `${jobTitle}`;
    if (companyName) {
      description += ` na ${companyName}`;
    }
    if (location) {
      description += ` - ${location}`;
    }
    description += ` | Salário: ${salary}`;
    
    const pageUrl = `/offers/${this.props.params?.offer_id}/details`;
    const logoUrl = 'https://empregamecanico.com.br/assets/images/logo.png';
    
    updateMetaTags({
      title: `${jobTitle} - Emprega Mecânico`,
      description: description,
      image: logoUrl,
      url: pageUrl,
      type: 'article'
    });
  }

  shareOnWhatsApp = () => {
    const jobTitle = this.state.job_titles[this.state.offer.basic_info.job_title_id] || 'Vaga de Emprego';
    const companyName = this.state.offer.basic_info.company_name || '';
    const location = this.state.offer.basic_info.city_display_name || '';
    const salary = this.state.offer.benefits.show_salary && this.state.offer.benefits.salary > 0
      ? this.BRLReal.format(this.state.offer.benefits.salary)
      : 'A combinar';
    
    const pageUrl = `https://empregamecanico.com.br/offers/${this.props.params?.offer_id}/details`;
    
    // Criar mensagem para compartilhar sem emojis para evitar problemas de encoding
    let message = `*${jobTitle}*`;
    if (companyName) {
      message += `\nEmpresa: ${companyName}`;
    }
    if (location) {
      message += `\nLocal: ${location}`;
    }
    message += `\nSalário: ${salary}`;
    message += `\n\nVeja mais detalhes: ${pageUrl}`;
    
    // Codificar a mensagem para URL (encodeURIComponent preserva UTF-8 corretamente)
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/?text=${encodedMessage}`;
    
    // Abrir WhatsApp
    window.open(whatsappUrl, '_blank');
  }

  render() {
    return (
      <div className='job-offer-details company-page'>
      <div className='summary block'>
        <div className='title-row'>
          <h3>{this.state.job_titles[this.state.offer.basic_info.job_title_id]}</h3>
          <div className='title-actions'>
            {/* Vaga cancelada não é pública -> não faz sentido compartilhar */}
            {!(this.state.jobStatus || '').includes('cancel') && (
            <button
              className='share-whatsapp-btn'
              onClick={this.shareOnWhatsApp}
              title="Compartilhar no WhatsApp"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="18" cy="5" r="3"></circle>
                <circle cx="6" cy="12" r="3"></circle>
                <circle cx="18" cy="19" r="3"></circle>
                <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
                <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
              </svg>
            </button>
            )}
            {this.state.usertype && this.state.usertype === 'candidate' &&
            <img onClick={this.toggleSavedJob} src={this.state.saved ? savedIcon : notSavedIcon} alt={this.state.saved ? 'saved' : 'not-saved'} />}
          </div>
        </div>
        <div className='section basic-info-section'>
          <div className='columns'>
            {(() => {
              const company = (this.state.offer.basic_info.company_name ?? '').toString().trim();
              if (!company) return null;
              return (
                <div className='column'>
                  <p>Nome da empresa:</p>
                  <b>{company}</b>
                </div>
              );
            })()}
            {(() => {
              const locality = (this.state.offer.basic_info.city_display_name ?? '').toString().trim();
              if (!locality) return null;
              return (
                <div className='column'>
                  <p>Localização:</p>
                  <b>{locality}</b>
                </div>
              );
            })()}
            {this.state.offer.basic_info.quantity !== undefined && this.state.offer.basic_info.quantity !== null && (
              <div className='column'>
                <p>Quantidade de vagas:</p>
                <b>{this.state.offer.basic_info.quantity} vaga{this.state.offer.basic_info.quantity > 1 ? 's' : ''}</b>
              </div>
            )}
            {(() => {
              const jobTypeKey = this.state.offer.basic_info.job_type?.toLowerCase();
              const jobTypeName = jobTypeKey ? this.state.job_types[jobTypeKey] : undefined;
              if (!jobTypeName) return null;
              return (
                <div className='column'>
                  <p>Tipo de contratação:</p>
                  <b>{jobTypeName}</b>
                </div>
              );
            })()}
          </div>
          {(() => {
            const jd = (this.state.offer.basic_info.job_description ?? '').toString().trim();
            if (!jd) return null;
            return (
              <div className='section about-section'>
                <div className='section-header'>
                  <h4>Sobre a vaga:</h4>
                </div>
                <div className='about-content' dangerouslySetInnerHTML={{__html: jd}} />
              </div>
            );
          })()}
        </div>
        <div className='section benefits-section'>
          <div className='section-header'>
            <h4>Salário e benefícios:</h4>
          </div>
          <div className='columns'>
            <div className='column'>
              <p>Salário:</p>
              <b>
                {
                  this.state.offer.benefits.show_salary ?
                  this.BRLReal.format(this.state.offer.benefits.salary) : 
                  'A combinar'
                }
              </b>
            </div>
            {(() => {
              const comission = (this.state.offer.benefits.comission ?? '').toString().trim();
              if (!comission) return null;
              return (
                <div className='column'>
                  <p>Comissão:</p>
                  <b>{comission}</b>
                </div>
              );
            })()}
            {Array.isArray(this.state.offer.benefits.benefits) && this.state.offer.benefits.benefits.length > 0 && (
              <div className='column'>
                <p>Benefícios:</p>
                <div className='selections'>
                  {this.state.offer.benefits.benefits.map((benefit: any, index: number) =>
                  <b key={'benefit_'+benefit.benefit_id+'_'+index} className='selection'>{benefit.benefit_name}</b>)}
                </div>
              </div>
            )}
          </div>
        </div>
        <div className='section requirements-section'>
          <div className='section-header'>
            <h4>Requisitos:</h4>
          </div>
          <div className='columns'>
            {(() => {
              const eduKey = this.state.offer.requirements.minimum_education;
              const eduName = eduKey ? this.state.education_levels[eduKey] : undefined;
              if (!eduName) return null;
              return (
                <div className='column'>
                  <p>Escolaridade:</p>
                  <b>{eduName}</b>
                </div>
              );
            })()}
            {this.state.offer.requirements.minimum_experience !== undefined && this.state.offer.requirements.minimum_experience !== null && (
              <div className='column'>
                <p>Experiência mínima:</p>
                <b>{
                  this.state.offer.requirements.minimum_experience === '0' ? 
                  'Indiferente' : 
                  `${parseInt(this.state.offer.requirements.minimum_experience)} ${parseInt(this.state.offer.requirements.minimum_experience) < 2 ? 'ano' : 'anos'}`
                }</b>
              </div>
            )}
          </div>
          {Array.isArray(this.state.offer.requirements.required_skills) && this.state.offer.requirements.required_skills.length > 0 && (
            <div>
              <p>Habilidades obrigatórias:</p>
              <div className='selections'>
                {this.state.offer.requirements.required_skills.map((skill: any) =>
                <b key={'required_skill_'+skill} className='selection'>{this.state.skills[skill]}</b>)}
              </div>
            </div>
          )}
          {Array.isArray(this.state.offer.requirements.desired_skills) && this.state.offer.requirements.desired_skills.length > 0 && (
            <div>
              <p>Habilidades opcionais:</p>
              <div className='selections'>
                {this.state.offer.requirements.desired_skills.map((skill: any) =>
                <b key={'desired_skill_'+skill} className='selection'>{this.state.skills[skill]}</b>)}
              </div>
            </div>
          )}
          {Array.isArray(this.state.offer.requirements.recommended_courses) && this.state.offer.requirements.recommended_courses.length > 0 && (
            <div>
              <p>Cursos recomendados:</p>
              <ul className='recommended-courses'>
                {this.state.offer.requirements.recommended_courses.map((course: any) =>
                  <li key={'course_'+course}><b>{this.state.courses[course+''] || ('Curso #' + course)}</b></li>
                )}
              </ul>
            </div>
          )}
        </div>
        {
          this.state.usertype && this.state.usertype === 'candidate' && this.state.user_applied === false &&
          <div className='bottom-btns'>
            <button className='primary' onClick={this.onSubmit}>Candidatar-se</button>
          </div>
        }
        <ResponseModal
        render={this.state.responseData}
        type={this.state.responseData?.type}
        title={this.state.responseData?.title}
        text={this.state.responseData?.text}
        onClose={() => {
          this.setState({ responseData: null });
          this.state.responseData?.type === 'success' && this.props.navigate('/offers');
        }} />
        
        <ValidationModal
          render={this.state.validationModal.isOpen}
          message={this.state.validationModal.message}
          missingFields={this.state.validationModal.missingFields}
          onClose={this.closeValidationModal}
          onCompleteProfile={this.goToProfileCompletion}
          helpText="Para se candidatar a vagas, complete essas informações no seu perfil."
        />
      </div>
      </div>
    )
  }
}

export default withRouter(JobOfferDetails);